import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import { ToastSliceRe } from './toast/toast';
import quizSlice from './quiz/quizSlice';
import quizTimerSlice from './quiz/timerSlice';
import courseSlice from './course/courseSlice';
import profileSlice from './profile/profileSlice';
import questionBankSlice from './questionBank/questionBankSlice';
import sessionTimingSlice from './sessionTiming/sessionTimingSlice';
import studySlice from './study/studySlice';
import gradeSlice  from './gradingModel/gradingModelSlice';
import irGradingSlice  from './IRGrading/IRGradingSlice';
import studentSlice from './student/studentSlice';
import activityReportSlice from './activityReport/activityReportSlice';
import speechConfigSlice  from './speechConfig/speechConfigSlice';
import diagnosticSlice from './diagnostic/diagnosticSlice';
import teacherDashboardSlice from './teacherDashboard/teacherDashboardSlice';
import scoringSlice from './scoring/scoringSlice';

const appReducer = combineReducers({
    auth: authReducer,
    toast: ToastSliceRe,
    quiz: quizSlice,
    timer: quizTimerSlice,
    course: courseSlice,
    profile: profileSlice,
    questionBank: questionBankSlice,
    grade: gradeSlice, 
    irGrade: irGradingSlice,
    speechConfig:speechConfigSlice,
    sessionTiming: sessionTimingSlice,
    study: studySlice,
    student: studentSlice,
    activityReport: activityReportSlice,
    diagnostic: diagnosticSlice,
    teacherDashboard: teacherDashboardSlice,
    scoring: scoringSlice,
});

const rootReducer = (state, action) => appReducer(state, action);

export default rootReducer;
